var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-h6 lighten-3 rounded-lg pa-4"},[_vm._v(" "+_vm._s(_vm.question_title)+" "),_c('small',{staticClass:"validate-warning"},[_vm._v(_vm._s(_vm.required_mark))])])
}
var staticRenderFns = []

export { render, staticRenderFns }